import * as ActionTypes from '../../constants/actionTypes';
import {cloneDeep} from "lodash";
import {WIZARD_GROUP_TYPES} from "./WizardItem/wizardItemInterface";
import {
  SET_WIZARD_BUFFER_ITEMS, SET_WIZARD_COPY_EDGES,
  SET_WIZARD_FILTERS_LOADING,
  SET_WIZARD_NODE_INPUT_FOCUSED
} from "../../constants/actionTypes";

export const WIZARD_POPUP_TYPES = {
  sceneSelection: 1,
  editGroup: 2,
  featuresExclusion: 3,
  filtersExclusion: 4,
  start: 5,
  cloneWizard: 6,
  inputsSetup: 7,
  editItemToggles: 8,
}

const initialState = {
  wizardVisualizer: "",
  wizardList: [],
  wizardPendingList: [], // this is storing wizardList copy until cancel clicked
  wizardListReceived: false,
  wizardPopupType: WIZARD_POPUP_TYPES.sceneSelection,
  wizardPopupOpened: false,
  wizardPopupItem: null, // object
  wizardPopupGroup: null, // object
  wizardPopupFiltersOpened: false,
  wizardPopupFiltersSearchText: "",
  wizardPopupDisabledScenes: [],
  wizardPopupEditToggles: {},
  wizardFlowActiveMode: WIZARD_GROUP_TYPES.group,
  wizardNodesCount: 0, // this is needed to update flow only when parent changes affects canvas
  wizardDraggingGroupIndex: null,
  wizardFiltersLoading: false, // when we need to receive filter groups for feature groups
  wizardCloneLogic: {
    visible: false,
    toFabricator: 0,
    cloneStep: 0,
    wizardName: "",
    cloneGroupName: "",
    finished: false
  },
  bufferWizardNodes: [],
  bufferWizardEdges: [],
  bufferWizardItem: null,
  shouldCopyEdges: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_WIZARD_VISUALIZER:
    case ActionTypes.SET_WIZARD_LIST:
    case ActionTypes.SET_WIZARD_LIST_RECEIVED:
    case ActionTypes.SET_WIZARD_PENDING_LIST:
    case ActionTypes.SET_WIZARD_POPUP_DISABLED_SCENES:
    case ActionTypes.SET_WIZARD_POPUP_OPENED:
    case ActionTypes.SET_WIZARD_POPUP_ITEM:
    case ActionTypes.UPDATE_WIZARD_POPUP_ITEM:
    case ActionTypes.SET_WIZARD_POPUP_FILTERS_OPENED:
    case ActionTypes.SET_WIZARD_POPUP_FILTERS_SEARCH_TEXT:
    case ActionTypes.SET_WIZARD_FLOW_ACTIVE_MODE:
    case ActionTypes.SET_WIZARD_DRAGGING_GROUP_INDEX:
    case ActionTypes.SET_WIZARD_FILTERS_LOADING:
    case ActionTypes.SET_WIZARD_NODE_INPUT_FOCUSED:
    case ActionTypes.SET_WIZARD_BUFFER_ITEMS:
    case ActionTypes.SET_WIZARD_POPUP_EDIT_TOGGLES:
    case ActionTypes.SET_WIZARD_COPY_EDGES:
      return Object.assign({}, state, {
        ...action.payload,
      });
    case ActionTypes.UPDATE_WIZARD_NODES_COUNT: // this is needed to update flow only when parent changes affects canvas
      return Object.assign({}, state, {
        wizardNodesCount: state.wizardNodesCount + 1,
      });
    case ActionTypes.WIZARD_PENDING_LIST_REVERT:
      return Object.assign({}, state, {
        wizardList: cloneDeep(state.wizardPendingList),
        wizardPendingList: []
      });
    case ActionTypes.SET_WIZARD_CLONE_LOGIC:
      return Object.assign({}, state, {
        wizardCloneLogic: {...state.wizardCloneLogic, ...action.payload.wizardCloneLogic},
      });
  }
  return state;
}
